import { render, staticRenderFns } from "./AppCookie.vue?vue&type=template&id=f4c20d80&"
import script from "./AppCookie.vue?vue&type=script&lang=js&"
export * from "./AppCookie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports